var map = {
	"./computers.svg": "3e0f",
	"./dropdown.svg": "8cc0",
	"./email.svg": "9055",
	"./energy.svg": "d66b",
	"./focus.svg": "3618",
	"./history/end.svg": "3a8d",
	"./history/point.svg": "6d87",
	"./history/start.svg": "e916",
	"./left_carot.svg": "8396",
	"./loading.svg": "4045",
	"./logo.svg": "9b19",
	"./manufacturing.svg": "da10",
	"./map.svg": "a086",
	"./phone.svg": "001e",
	"./quality.svg": "4f73",
	"./right_carot.svg": "2af5",
	"./security.svg": "b464",
	"./vision.svg": "392c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";